import React from 'react';
import AmountCalculator from './AmountCalculator';

export default function Index(props) {
    return <AmountCalculator {...props} />;
}
